import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../language.service'
@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
  isActive = false;
  isSubActive = false;
  currentPage: string;
  display = false;
  
  constructor(public languageService: LanguageService) { }


  ngOnInit() {
   this.languageService.currentPage.subscribe(cp => this.currentPage = cp);

  }

  get status(): string {
    return this.isActive ? 'is-active' : '';
  }

  get subStatus():string {
    return this.isSubActive ? 'sub-active' : '';
  }

  toggleSubMenu(): void {
    this.isSubActive = !this.isSubActive;
  }

  toggleMenu(): void {
    this.isActive = !this.isActive;
  }
  closeMenu(): void {
    this.isActive = false;
    this.isSubActive = false;

  }
}
